export default __webpack_public_path__ + "imgs/start-img.png";